import React from "react";
import {AirplaneTilt, Calendar, CalendarPlus, CaretLeft, Lifebuoy, Shield, ShieldCheck, Target } from '@phosphor-icons/react';
// import { CalendarDots } from '@ant-design/icons';
import {
  Container,
  Header,
  BackButton,
  ImageBox,
  Section,
  Cards,
  Card,
  IconsGrid,
  IconCard,
  Explication,
} from "./styles";
import image from "../src/imagemRendaFixa.png";
import { BiCalendarStar } from "react-icons/bi";

interface Props {
  onBack: () => void;
}

export const RendaFixaInfo: React.FC<Props> = ({ onBack }) => {
  return (
    <Container>
        {/* Cabeçalho */}
        <Header>
            <div className="titulo">
                <h1>Saiba mais sobre Renda Fixa</h1>
                <BackButton onClick={onBack}><CaretLeft width={20} height={20} fill="#EC6643" />Voltar</BackButton>
            </div> 
            <p>
            Invista com segurança, previsibilidade e comece a construir seus sonhos hoje mesmo. 
            Conheça os tipos de ativos, veja como funcionam e entenda por que a Renda Fixa 
            é ideal para quem quer começar com confiança.
            </p>
        </Header>
        <Explication>
            {/* O que é renda fixa */}
            <Section>
                <h2>O que é Renda Fixa?</h2>
                <p>
                    Renda Fixa é uma modalidade de investimento em que desde o início você já consegue saber como será a rentabilidade. 
                    É ideal para quem busca estabilidade, menor risco e objetivos bem definidos como uma reserva de emergência, 
                    a compra de um bem ou viagens.
                </p>
            </Section>
            {/* Imagem ilustrativa */}
            <ImageBox>
                <img src={image} alt="Renda fixa explicação" />
            </ImageBox>
        </Explication>
        {/* Como funciona */}
        <Section>
            <h2>Como funciona um investimento de Renda Fixa?</h2>
            <p>
            Você empresta dinheiro para o governo ou empresas por um prazo determinado. 
            Em troca, recebe juros sobre o valor investido. Ao final do período, você resgata o valor aplicado com rendimento.
            </p>
        </Section>

        {/* Tipos de renda fixa */}
        <Section>
            <h2>Quais os tipos de Renda Fixa?</h2>

            <Cards>
            <Card>
                <div style={{
                    display: 'flex',
                    gap: '16px',
                    alignItems: 'center',
                    alignSelf: 'stretch',
                }}>
                    <Calendar size={32} fill="#EC6643" />
                    Pré-fixado
                </div>
                <div className="cards-renda">
                    <p>• Rentabilidade predefinida</p>
                    <p>• Sabe o rendimento desde o início</p>
                    <p>• Pode perder para a inflação</p>
                    <p>• % ao ano = % a.a.</p>
                </div>
            </Card>

            <Card>
                <div style={{
                    display: 'flex',
                    gap: '16px',
                    alignItems: 'center',
                    alignSelf: 'stretch',
                }}>
                    <CalendarPlus size={32} fill="#EC6643" />
                    Pós-fixado
                </div>
                <div className="cards-renda">
                    <p>• Rentabilidade por indicadores</p>
                    <p>• Só sabe o rendimento no final</p>
                    <p>• Difícil perder para a inflação</p>
                    <p>• % do CDI, SELIC, IPCA e etc.</p>
                </div>
            </Card>

            <Card>
                <div style={{
                    display: 'flex',
                    gap: '16px',
                    alignItems: 'center',
                    alignSelf: 'stretch',
                }}>
                    <BiCalendarStar size={32} fill="#EC6643"/>
                    Híbrido
                </div>
                <div className="cards-renda">
                    <p>Parte da rentabilidade é fixa e parte acompanha a inflação</p>
                    <p>Ex: (IPCA + taxa)</p>
                </div>
            </Card>
            </Cards>
        </Section>

        {/* Para quem é indicado */}
        <Section>
            <h2>Para quem é indicado?</h2>

            <IconsGrid>
                <IconCard>
                    <div className="border-icon">
                        <ShieldCheck width={32} height={32} fill="#EC6643"/>
                    </div>
                    <h4>
                        Quer segurança e previsibilidade
                    </h4>
                </IconCard>

                <IconCard>
                    <div className="border-icon">
                        <Target width={32} height={32} fill="#EC6643"/>
                    </div>
                    <h4>Está começando a investir</h4>
                </IconCard>

                <IconCard>
                    <div className="border-icon">
                        <Lifebuoy width={32} height={32} fill="#EC6643"/>
                    </div>
                    <h4>Busca montar uma reserva de emergência</h4>
                </IconCard>

                <IconCard>
                    <div className="border-icon">
                        <AirplaneTilt width={32} height={32} fill="#EC6643"/>
                    </div>
                    <h4>Tem objetivos com prazos definidos</h4>                   
                </IconCard>
            </IconsGrid>
        </Section>

    </Container>
  );
};

export default RendaFixaInfo;
